import React, { useEffect, useState } from 'react'
import { AntibioticItem } from './AntibioticItem'
import { AlertMessage, Container, Contents, LoadingContainer } from './styles'
import { SessionTitle } from '../SessionTitle'
import { IconComponent } from '~/assets/icons/component'
import { SpinnerIconLoader } from '~/components/shared'
import { useLaboratoryHealthProcedures, usePatient } from '~/context'
import { message } from '~/services'

const Antibiotics: React.FC = () => {
  const { getAntibiotics, antibiotics } = useLaboratoryHealthProcedures()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { patient } = usePatient()

  useEffect(() => {
    getAntibiotics({
      pathParams: { patientId: patient.id }
    }).then(() => {
      setIsLoading(false)
    })
  }, [getAntibiotics, patient.id])

  const renderLoading = () => {
    return (
      <LoadingContainer>
        <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
      </LoadingContainer>
    )
  }

  const renderMessage = () => {
    return (
      <AlertMessage>
        <span>{message('laboratory.not_found_antibiotics')}</span>
      </AlertMessage>
    )
  }

  const renderContent = () => {
    return (
      <ul>
        {antibiotics!.map((_antibiotic, index) => (
          <AntibioticItem key={index} antibiotic={_antibiotic} />
        ))}
      </ul>
    )
  }

  const render = () => {
    if (isLoading && !antibiotics) return renderLoading()
    if (!isLoading && !antibiotics?.length) return renderMessage()
    return renderContent()
  }

  return (
    <Container>
      <SessionTitle title={message('laboratory.history_of_antibiotic_use')} />
      <Contents>{render()}</Contents>
    </Container>
  )
}

export { Antibiotics }
